import React, { ReactNode } from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getEventSponsorGroupInitialValues } from '~admin/view/components/create-event/helper/create-event-initial-values.helper';
import { CreateSponsor } from '~admin/view/components/details/sponsor-details/create-sponsor.component';
import {
  EventSponsorGroupFormData,
  SponsorDetailsGroup,
} from '~admin/view/components/details/sponsor-details/sponsor-details-group.component';
import { Box } from '~common/components/box.component';
import { Button } from '~common/components/button/button.component';
import { Size } from '~common/components/button/button.helper';
import { Column } from '~common/components/column.component';
import { Color } from '~common/model/basics';
import { PlusIcon } from '~web/view/components/ui/icon/plus.icon';

export interface EventSponsorDetailsFromData {
  sponsorGroups?: EventSponsorGroupFormData[];
}

export const SponsorDetails: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <CreateSponsor />
      <FieldArray name={'sponsorGroups'}>
        {({ fields }): ReactNode => {
          const onRemove = (index: number): void => {
            fields.remove(index);
          };

          const onAdd = (): void => {
            fields.push(getEventSponsorGroupInitialValues());
          };

          return (
            <SponsorGroups>
              {fields.map((name: string, index: number) => (
                <SponsorDetailsGroup
                  key={name}
                  name={name}
                  onRemove={(): void => onRemove(index)}
                />
              ))}
              <ButtonContainer>
                <Button color={Color.White} size={Size.Small} onClick={onAdd}>
                  <StyledPlusIcon color={Color.Black} width={14} height={14} />
                  {t('details.sponsor.groups.addButton')}
                </Button>
              </ButtonContainer>
            </SponsorGroups>
          );
        }}
      </FieldArray>
    </Container>
  );
};

const Container = styled(Column)`
  flex: 1 1 auto;
  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  margin-bottom: 18px;
  align-items: flex-end;
`;

const ButtonContainer = styled(Box)`
  width: 100%;
  padding: 16px;
`;

const SponsorGroups = styled(Column)`
  width: 100%;
  padding: 0 16px;
`;

const StyledPlusIcon = styled(PlusIcon)`
  fill: currentColor;
  margin-right: 12px;
`;



// WEBPACK FOOTER //
// ./view/components/details/sponsor-details/sponsor-details.component.tsx